import * as React from "react";
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { SubNavigation, IMenuItem } from "../SubNavigation";
import HomeIcon from '@material-ui/icons/Home';
import { ListIcon } from '../../atoms/icons/ListIcon';
import AddIcon from '@material-ui/icons/Add';
import { Dispatch } from "redux";
import { RootActionCreators } from "../../../store";
import { useTranslation } from 'react-i18next';

// CSS
const useStyles = makeStyles((theme) => ({ }));

export enum OutreachNavigationPage {
    MijnOutreach = "MijnOutreach",
    List = "List",
    Registreren = "Registreren",
}

interface ICoolMenuItem extends IMenuItem {
    page: OutreachNavigationPage;
}

// All the incoming values
interface IProps {
    selected?: OutreachNavigationPage;
    children?: React.ReactNode;
}


// All Navigation Functions
export interface INaviagtions {
    toMijnOutreach: () => void;
    toList: () => void;
    toRegistreren: () => void;
}
export const mapNavigationsToProps =  (dispatch: Dispatch): INaviagtions => ({
    toMijnOutreach: () => dispatch(RootActionCreators.Navigate.ToOutreach()),
    toList: () => dispatch(RootActionCreators.Navigate.ToOutreachList()),
    toRegistreren: () => dispatch(RootActionCreators.Navigate.ToOutreachNew()),
});


// Outgoing functions
interface IDispatch {
    navigations: INaviagtions
}

// Actual Component
export type AllProps = IProps & IDispatch;
export const OutreachNavigation = (props: AllProps) => {
    const classes = useStyles(useTheme());
    const { t: tCommon } = useTranslation('common');
    const { t: tOutreach } = useTranslation('outreach');

    const pages: ICoolMenuItem[] = [
        {
            label: tCommon('myX', { x: tOutreach('outreach') }),
            icon: <HomeIcon />,
            page: OutreachNavigationPage.MijnOutreach,
            onClick: props.navigations.toMijnOutreach
        },
        {
            label: tCommon('list'),
            icon: <ListIcon />,
            page: OutreachNavigationPage.List,
            onClick: props.navigations.toList
        },
        {
            label: tCommon('add'),
            icon: <AddIcon />,
            page: OutreachNavigationPage.Registreren,
            onClick: props.navigations.toRegistreren
        },
    ];

    const selectedIndex = props.selected && pages.findIndex(item => item.page === props.selected);
    if (selectedIndex === -1) {
        throw new Error("Selected page not found in pages array");
    }   

    return (<SubNavigation menuItems={pages} selectedIndex={selectedIndex}>{props.children}</SubNavigation>)
}